
<div class="d-flex mt-1 ">

  <div class="grid formgrid p-fluid ">
    <!-- <div *ngIf="!isRespigimento"></div> -->
      <div *ngIf="!isRespigimento && !isTIMSupport && !pratica.isVerbaleOK" class="field col-12">
        <label for="noteVerbale" >Note <strong>VERBALE DI ATTIVAZIONE</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteVerbale" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteVerbaleFase2}}</textarea>
        </span>
      </div>
      <div *ngIf="!isRespigimento && !isTIMSupport && !pratica.isDuvriOK" class="field col-12">
        <label for="noteAllegati" >Note <strong>ALLEGATI</strong></label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteAllegati" rows="3" [autoResize]="true"  pInputTextarea [disabled]="true">{{pratica.noteAllegatiFase2}}</textarea>
        </span>
      </div>
      <div *ngIf="!isRespigimento && isTIMSupport && pratica.noteBocciaturaTIMSupport" class="field col-12">
<!--         <label for="noteBocciaturaTIMSupport" >Note <strong>TIM SUPPORT</strong></label>
 -->        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteBocciaturaTIMSupport" rows="3" [autoResize]="true" class="font-bold"  pInputTextarea [disabled]="true">{{pratica.noteBocciaturaTIMSupport}}</textarea>
        </span>
      </div>
      <div *ngIf="isRespigimento" class="field col-12">
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="noteVERBALE" rows="3" [autoResize]="true" class="font-bold"  pInputTextarea [disabled]="true">{{pratica.noteBocciaturaInfratelFase2?pratica.noteBocciaturaInfratelFase2.toUpperCase():''}}</textarea>
        </span>
   
    </div>
  </div>
<div class=" mt-2" style="text-align: center;">
  <button *ngIf="!isTIMSupport" pButton pRipple icon="pi pi-cloud-download" (click)="scaricaReport()" label="SCARICA REPORT" class="p-button-outlined w-5 mt-1 mr-1"></button>

  <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="p-button-outlined w-5 mt-1"></button>
</div> 
<p-toast />
<p-confirmDialog /> 